var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.partners,"label":"Tipo de Parceiro","item-text":"title","item-value":"business","return-object":"","prepend-icon":"work_outline"},model:{value:(_vm.partner),callback:function ($$v) {_vm.partner=$$v},expression:"partner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }